import { Link } from "react-router-dom";
import SmartImage from "@/components/base/SmartImage";

export default function FinalCTA() {
  return (
    <section className="relative w-full h-[420px] md:h-[620px] overflow-hidden bg-background-50">
      <SmartImage
        src="https://storage.helloreaddy.io/project_files/e02ced6d-98bc-4ba1-a643-ca5b440d11d8/8f9e04bf-1e0e-47ac-8013-a3f78748a8bf_compressed_home-final-cta-mountain-valley-web.webp"
        alt="Outside is waiting"
        tone="dark"
        eager
        imgClassName="absolute inset-0 w-full h-full object-cover object-[70%_center]"
      />
      <div className="absolute inset-0 bg-gradient-to-tr from-black/40 via-black/10 to-transparent"></div>

      <div className="relative z-10 h-full w-full px-5 md:px-10 flex flex-col justify-end pb-12 md:pb-20">
        <div className="grid grid-cols-1 md:grid-cols-12 items-end gap-6 md:gap-8">
          <h2 className="md:col-span-8 text-[32px] md:text-[60px] leading-[1.08] md:leading-[1.0] tracking-[-0.02em] text-foreground-50 font-light">
            Outside is waiting.
          </h2>
          <div className="md:col-span-4 md:col-start-9 flex md:justify-end">
            <Link
              to="/shop"
              className="inline-flex items-center gap-3 px-6 md:px-7 min-h-[48px] bg-primary-500 hover:bg-primary-600 text-foreground-50 text-[14px] md:text-[13px] rounded-full transition cursor-pointer whitespace-nowrap"
            >
              Shop all gear <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}